import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';
import {selectFiles} from "../../bulk_uploader/BulkDndPlaceholder";
import upl_img from '../../../assets/img/file-upload.svg'
import UploadAPI from "../../../api/UploadAPI";
import {translate} from "../../../utils/Translate";

export default function SimpleFileUploader(props) {
    const {
        currentImage = '',
        mode = 'system',
        onSave = url => {

        },
        placeholder = 'загрузить файл',
        anotherPlaceholder = 'загрузить другой файл',
    } = props;

    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState();
    const [uploaded, setUploaded] = useState(false);
    const [uploadedUrl, setUploadedUrl] = useState(props?.url);

    return (
        <Wrapper>

            <FilePicker onClick={async () => {
                if (uploading == true) {
                    return;
                }
                let myFiles = await selectFiles();
                setUploading(true);
                let pld;
                if (mode == 'system') {
                    pld = await UploadAPI.uploadFile(myFiles[0], pr => {
                        setProgress(pr);
                    });
                }
                if (mode == 'user') {
                    pld = await UploadAPI.uploadUserFile(myFiles[0], pr => {
                        setProgress(pr);
                    });
                }
                setUploading(false);
                setProgress(undefined);
                setUploaded(true);
                console.log('pld = ', pld);
                setUploadedUrl(pld?.url);
                onSave(pld?.url);
            }}>
                <FilePickerImg src={upl_img}/>
                <FileUploadSpan>
                    {uploadedUrl == undefined && currentImage == '' ? placeholder : anotherPlaceholder}
                </FileUploadSpan>
            </FilePicker>

            {uploading == false ? null :
                <div>
                    {`${translate('loading')} ${progress == undefined ? '' : `${Math.round(progress)}%`}`}
                </div>
            }

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;


const FileUploadSpan = styled.div`

`;

const FilePicker = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  :hover {
    opacity: 0.85;
  }
`;


const FilePickerImg = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;